import { render } from "./ViewRecord.vue?vue&type=template&id=32394646&scoped=true"
import script from "./ViewRecord.vue?vue&type=script&lang=js"
export * from "./ViewRecord.vue?vue&type=script&lang=js"

import "./ViewRecord.vue?vue&type=style&index=0&id=32394646&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32394646"]])

export default __exports__